import * as React from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

export default function Filter({selectedSport = "", setSelectedSport, sportsList}) {

  const handleChange = (event) => {
    setSelectedSport(event.target.value);
  };

  return (
      <FormControl sx={{ width : '250px', m : 1}}>
        <InputLabel>Tous les sports</InputLabel>
        <Select
          value={selectedSport}
          label="Tous les sports"
          onChange={handleChange}
        >
            {sportsList.map((sport, index) => <MenuItem key={`${sport}-${index}`} value={sport}>{sport}</MenuItem>)}
        </Select>
      </FormControl>
  );
}
